import appConfig from '../../config/config';
import { log } from '../../common/common';
import { logoutUser } from './login.action';
import axiosInstance from '../helper/axiosInstance';
import { GET_POSITION_LIST, REACHED_SUMMARY } from '../constants/election.constant';
import axios from 'axios';

const url = appConfig.apiLoc;
//https://developer.clirnet.com/knowledge/rnv21/election/nominieslist?election_id=39
export const fetchNomineeList = (election_id, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`election/nominieslist?election_id=${election_id}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
      });
  };
};
export const fetchNomineeListByToken = (election_id, token, callback) => {
  return async (dispatch) => {
    axios({
      url: `${url}election/nominieslist?election_id=${election_id}`,
      method: 'GET',
      headers: {
        Authorization: token
      }
    })
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
      });
  };
};
export const postVote = (ballot, audit, callback) => {
  return async (dispatch) => {
    axiosInstance
      .post('election/ballotbox', [{ ballot: ballot, audit: [audit] }])
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
      });
  };
};
export const getPositionList = (payload) => {
  return {
    type: GET_POSITION_LIST,
    payload
  };
};

export const decideReachedSummary = (payload) => {
  return {
    type: REACHED_SUMMARY,
    payload
  };
};
// [
//   {
//     ballot: [
//       {
//         election_id: 3,
//         channel_id: 3,
//         position_id: 3,
//         nominie_id: 3,
//         user_master_id: 1,
//       },
//       {
//         election_id: 3,
//         channel_id: 3,
//         position_id: 3,
//         nominie_id: 3,
//         user_master_id: 1,
//       },
//       {
//         election_id: 3,
//         channel_id: 3,
//         position_id: 3,
//         nominie_id: 3,
//         user_master_id: 1,
//       },
//     ],
//     audit: [
//       {
//         platform: 'Windows 11',
//         version: '5.3.2',
//         browser: 'Chrome',
//         browser_version: '100.36.35.69',
//         mobilenumber: '8334858901',
//         mobilemodel: 'Nexus 5',
//         user_master_id: 1,
//       },
//     ],
//   },
// ];
